<template>
    <div>
        <van-empty v-if="chatList.length == 0" description="发挥您的创意,让AI帮您生成精美的图片吧~" />
        <div v-else style="padding-top: 5%;">
            <ChatView ref="chat_view_message" :isSet="true" :chatList="chatList" @insertMethod="insertMethod" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        chatList: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    components: {
        ChatView: () => import('./chatView/ChatView.vue'),
    },
    methods: {
        copyMethod(value) {
            // 复制方法
            this.$emit('copyMethod', value, 'imagine')
        },
        insertMethod(value) {
            // 插入方法
            this.$emit('insertMethod', value, 'imagine')
        },
        setLoadding(flag) {
            this.$nextTick(() => {
                this.$refs.chat_view_message.setLoadding(flag)
            })
        },
    },
}
</script>